/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserLoyaltyEventsResult } from '../../models/get-user-loyalty-events-result';

export interface GetUserLoyaltyEvents$Params {
  PageIndex?: number;
  PageSize?: number;
  SiteName?: string;
}

export function getUserLoyaltyEvents(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserLoyaltyEvents$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUserLoyaltyEventsResult>> {
  const rb = new RequestBuilder(rootUrl, getUserLoyaltyEvents.PATH, 'get');
  if (params) {
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserLoyaltyEventsResult>;
    }),
  );
}

getUserLoyaltyEvents.PATH = '/Loyalty/user-loyalty-events';
